import { ChangeDetectionStrategy, Component, input, type TemplateRef, viewChild } from '@angular/core';

@Component({
    styleUrls: ['./ui-form-error.scss'],
    selector: 'ui-form-error',
    templateUrl: 'ui-form-error.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFormErrorComponent {
    template = viewChild<TemplateRef<any>>('template');

    /**
     * If this is filled, the error will automatically be filtered based on the control errors
     */
    errorCode = input<string>();
}
